var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SearchableTable',{attrs:{"panel-header":'Ärzte',"panel-route":'AddDoctor',"show-search-bar":true,"table-data":_vm.doctors,"table-meta-data":_vm.tableMetaData,"query-string":'setSearchQuery',"initial-search-query":_vm.searchQuery,"row-click":_vm.triggerView,"event-value":_vm.parentEventValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }